var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.prefix},[_c('div',{class:`${_vm.prefix}_content`},[_c('div',{class:`${_vm.prefix}_content-box`},[_c('user-center',{attrs:{"message":_vm.$message,"userInfo":_vm.userInfo},on:{"success":_vm.updateUser,"modifyPassword":_vm.handleModifyPasswordSuccess}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }